//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Download_Log_FIN } from 'src/app/Constants/Backlog/FIN/Download_Log_FIN';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Check, Filter_Check_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Annexe, FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Data_VH_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_VH_FIN.interface';
import { Header_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Header_FIN.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { permissionSystemFolderFIN, PermissionSystemFolderFINType, tpermissionFolderFIN } from 'src/app/types/FIN/permissionFolderFIN.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';




@Component({
    selector: 'app-version-history-fin',
    templateUrl: './version-history-fin.component.html',
    styleUrls: ['./version-history-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/VersionHistoryGlobal.css'],
    standalone: false
})

export class VersionHistoryFINComponent implements OnInit {

  private readonly VersionHistoryAllowedHeaders: string[] = [
    'DOWNF',
    'NAMFI',
    'ANNEX',
    'CODEF',
    'DESCR',
    'NOREV',
    'CONTR',
    'DACRE',
    'DAEXP',
    'APPR1',
    'APPR2',
    'APPR3',
    'APPR4',
    'STATU',
  ];


  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-slash', Description: 'El usuario no fue requerido en el flujo' },
    { Icon: 'fa-user-pen', Description: 'El Proceso está siendo revisado' },
    { Icon: 'fa-user-clock', Description: 'El proceso está pendiente de pasar al siguiente nivel de aprobación' },
    { Icon: 'fa-user-check', Description: 'El Proceso ha sido revisado y aprobado' },
    { Icon: 'fa-user-xmark', Description: 'El Proceso ha sido revisado y rechazado' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido aprobado por un administrador' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido rechazado por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del aprobador, El Proceso puede ser muy antiguo' }
  ];

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersVH: Header_FIN[] = [
    { ID: 1, Name: 'Descargar', Position: 1, Visible: true, Key_Header: 'DOWNF' },
    { ID: 1, Name: 'Nombre del Proceso', Position: 1, Visible: true, Key_Header: 'NAMFI' },
    { ID: 1, Name: 'Anexos', Position: 1, Visible: true, Key_Header: 'ANNEX' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'CODEF' },
    { ID: 1, Name: 'Objetivo del proceso', Position: 1, Visible: true, Key_Header: 'DESCR' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOREV' },
    { ID: 1, Name: 'Contribuidor', Position: 1, Visible: true, Key_Header: 'CONTR' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DACRE' },
    { ID: 1, Name: 'Fecha de aprobación', Position: 1, Visible: true, Key_Header: 'DAEXP' },
    { ID: 1, Name: 'Mgr. Process Owner', Position: 1, Visible: true, Key_Header: 'APPR1' },
    { ID: 1, Name: 'RM & ICS Specialist', Position: 1, Visible: true, Key_Header: 'APPR2' },
    { ID: 1, Name: 'RM & ICS Sr. Mgr.', Position: 1, Visible: true, Key_Header: 'APPR3' },
    { ID: 1, Name: 'Director or CFO', Position: 1, Visible: true, Key_Header: 'APPR4' },
    { ID: 1, Name: 'Estatus ', Position: 1, Visible: true, Key_Header: 'STATU' },
  ]

  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_VersionH: string = '';


  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_Folder: number = 0;
  private ID_DocFIN: number = 0;


  //+================== VARIABLE FOR ALL VERSION FIN ==================+\\
  public List_Histrory_Version_FIN: Data_VH_FIN[] = [];
  public SelectedList_Histrory_Version_FIN: Data_VH_FIN[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLE PERMISION ==================+\\
  private Permission_FMH: Permission_Folder_FIN = {
    ID: 0,
    Permission: [],
    Folder: { ID: 0, Name: '', ID_Folder_Top: 0, status: 0, Directory: false, Inheritance: 0, InheritanceGA: 0, Optional_Approvers: 0 },
    Users_Groups_For_Role:
    {
      G_Approvers_1: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_2: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_3: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_4: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
    }
  };
  public PermissionFIN: PermissionSystemFolderFINType = permissionSystemFolderFIN;

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;


  //+================== VARIABLES FOR CREDENTIALS USER ==================+\\
  private ID_User_BD: number = 0;

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
  };

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLE FOR ALL VERSION FIN ==================+\\
  public LoadPage: boolean = false;

  public FFIN_Select_CM: Data_VH_FIN = {
    ID: 0,
    Name: '',
    Extension: '',
    Code: '',
    Purpose: '',
    Revision_No: 0,
    Status: 0,
    Area: null,
    Shop: null,
    ID_Folder: 0,
    TaskApprover1: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: '',
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover2: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: '',
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover3: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: '',
      Date_Start: null,
      Date_End: null,
    },
    TaskApprover4: {
      ID: 0,
      ID_WF: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
      Comment: '',
      Date_Start: null,
      Date_End: null,
    },
    Date_Created: null,
    Date_Modification: null,
    Date_Expiration: null,
    Date_End: null,
    ID_Contributor: 0,
    ID_Previous_Version: 0,
    ID_Next_Version: 0,
    Status_System: 0,
    Annexes: [],
    Approver1_Name: '',
    Approver2_Name: '',
    Approver3_Name: '',
    Approver4_Name: '',
    Contributor_Name: '',
    Directory: false,
    Path: ''
  }

  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private Service_FIN = inject(LibraryFINService);
  private activatedRouter = inject(ActivatedRoute);
  private PermissionFolder = inject(PermisionsFolderService);

  constructor() {
    this.ID_Folder = this.activatedRouter.snapshot.params['idF'];
    this.ID_DocFIN = this.activatedRouter.snapshot.params['idH'];
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component_VH();
  }

  private async Load_Component_VH(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResGetHeaders: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Headers());
      if (ResGetHeaders.success && Array.isArray(ResGetHeaders.operation) && ResGetHeaders.operation.length > 0) {
        this.HeadersVH = ResGetHeaders.operation.filter((header: Header_FIN) =>
          this.VersionHistoryAllowedHeaders.includes(header.Key_Header)
        );
      }

      const Permisions_Level: Permission_Folder_FIN = await this.PermissionFolder.GetPermissionsInFolderFIN(this.ID_User_BD, this.ID_Folder);

      this.Permission_FMH = Permisions_Level;

      const ResVersionHistory: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Version_History({ ID_WF: this.ID_DocFIN }));

      if (ResVersionHistory.success) {
        this.List_Histrory_Version_FIN = ResVersionHistory.operation;

        this.Generate_Filters();
      }

      Loader.classList.remove('active');
      this.LoadPage = true;


    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar el historial de versiones del Proceso, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }


  //&===================== FUNCTION FOR FILTERS =====================&\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Contributor_Name: [],
    };

    for (const FIN of this.List_Histrory_Version_FIN as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = moment(FIN.Date_Expiration).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Approver1_Name = { Value: FIN.Approver1_Name } as Data_Check;
      FIN.F_Approver2_Name = { Value: FIN.Approver2_Name } as Data_Check;
      FIN.F_Approver3_Name = { Value: FIN.Approver3_Name } as Data_Check;
      FIN.F_Approver4_Name = { Value: FIN.Approver4_Name } as Data_Check;
      FIN.F_Contributor_Name = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some(item => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some(item => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Approver1_Name.some(item => item.Value === FIN.Approver1_Name) && FIN.Approver1_Name !== null) {
        this.Filter_Global_Check.Approver1_Name.push({ Value: FIN.Approver1_Name })
      }

      if (!this.Filter_Global_Check.Approver2_Name.some(item => item.Value === FIN.Approver2_Name) && FIN.Approver2_Name !== null) {
        this.Filter_Global_Check.Approver2_Name.push({ Value: FIN.Approver2_Name })
      }

      if (!this.Filter_Global_Check.Approver3_Name.some(item => item.Value === FIN.Approver3_Name) && FIN.Approver3_Name !== null) {
        this.Filter_Global_Check.Approver3_Name.push({ Value: FIN.Approver3_Name })
      }

      if (!this.Filter_Global_Check.Approver4_Name.some(item => item.Value === FIN.Approver4_Name) && FIN.Approver4_Name !== null) {
        this.Filter_Global_Check.Approver4_Name.push({ Value: FIN.Approver4_Name })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some(item => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

    }


  }

  //&===================== END FUNCTION FOR FILTERS =====================&\\




  //&===================== FUNCTIONS FOR GENERAL VERSION HISTORY =====================&\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  public DateFormat_Approved(Date: string | Date, Status: number): string {
    return Status === 2 ? ("N/A") : (moment(Date).utc().format('DD/MM/YYYY hh:mm:ss a'));
  }

  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  public SeeReason_Approver(FIN: any, ID_Approver: number): void {

    let Comment: string | null = null;

    if (FIN[`TaskApprover${ID_Approver}`].Comment != null) {
      Comment = FIN[`TaskApprover${ID_Approver}`].Comment;
    }

    if (Comment === null) {
      Comment = 'El archivo fue rechazado en el antiguo sistema o sucedió algún inconveniente y no tenemos la razón de rechazo.'
    }

    if (FIN.Status === 3 && FIN[`TaskApprover${ID_Approver}`].Status === 4) {

      Swal.fire({
        title: 'Comentarios',
        text: `¡${Comment}!`,
        confirmButtonColor: this.ColorConfirm
      })

    } else if (FIN[`TaskApprover${ID_Approver}`].Status === 6) {
      Swal.fire({
        title: 'Comentarios',
        html: `¡El proceso fue rechazado por el administrador <b>${FIN[`TaskApprover${ID_Approver}`].FlowAdminName}</b>!<br><br><b>Comentario: </b>${Comment}`,
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  public seeApproverAdmin(FIN: any, ID_Approver: number): void {
    if (FIN.Status === 1 && FIN[`TaskApprover${ID_Approver}`].Status === 5) {

      Swal.fire({
        title: 'Usuario administrador aprobador',
        text: `¡${FIN[`TaskApprover${ID_Approver}`].FlowAdminName}!`,
        confirmButtonColor: this.ColorConfirm
      })

    }
  }

  public SeeToolTip_Rejected_Approver(FIN: any, ID_Approver: number): boolean {
    return (FIN.Status === 3 && (FIN[`TaskApprover${ID_Approver}`].Status === 4 || FIN[`TaskApprover${ID_Approver}`].Status === 6))
  }

  public SeeToolTip_Approved_Admin(FIN: any, ID_Approver: number): boolean {
    return (FIN.Status === 1 && FIN[`TaskApprover${ID_Approver}`].Status === 5)
  }

  //-============== FUNCTION FOR ADD CLASS ANNEXE ==============-\\
  public Contain_Annexe(Annexe: Annexe[]): string {

    return Annexe.length === 0 ? 'Not-Annexe' : 'Annexe';
  }

  //-============== FUNCTION FOR TEXT IF CONTAINS ANNEXE ==============-\\
  public Contain_Annexe_Text(Annexe: Annexe[]): string {

    return Annexe.length === 0 ? 'Sin anexos' : 'Ver annexos';
  }

  //-================== FUNCTION FOR CUT CODE ==================-\\
  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  //-================== FUNCTION FOR SEE CODE COMPLETE ==================-\\
  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 32 ? Purpose.slice(0, 32) + '...' : Purpose;
  }

  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  //-============== FUNCTION FOR VERIFY IF CONTAINS ANNEXE ==============-\\
  public Can_See_Modal_Annexe(FIN: Data_VH_FIN): void {
    const hasPermission = this.UserRoleIn([this.PermissionFIN.versionHistoryAnnexe]) || this.UserService.UserRoleGeneralIn([GeneralRoleCDMS.AdministratorFIN]);
    if (!hasPermission) {
      Swal.fire('Acción no permitida', 'No tienes permisos para ver anexos de historial.', 'warning');
      return;
    }

    this.FFIN_Select_CM = FIN;
    this.Modal_See_Annexe(true);
  }

  //-============== FUNCTION FOR OPEN OR CLOSE MODAL, FOR SEE ANNEXE ==============-\\
  public Modal_See_Annexe(CloseOrOpen: boolean): void {
    const Modal_See_Annexe = document.getElementById('Modal-See-Annexe') as HTMLDivElement;
    CloseOrOpen ? Modal_See_Annexe.classList.add('active') : Modal_See_Annexe.classList.remove('active');
  }

  //-============== VALIDATION FUNCTION TO DOWNLOAD ANNEX ==============-\\
  public Can_Download_Annexe(Annexe: Annexe): void {

    const Permission: boolean = (this.UserRoleIn([this.PermissionFIN.downloadVersionAnnexe]) || this.UserService.UserRoleGeneralIn([GeneralRoleCDMS.AdministratorFIN]));

    Permission ? this.Get_Download_Annexe(Annexe) : this.Message_NP_Download_Annexe(Annexe);

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Get_Download_Annexe(Annexe: Annexe): Promise<void> {

    try {

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_Annexe_FIN({ ID_Annexe: Annexe.ID, Type_D: Download_Log_FIN.D_ANN_VERS_H_FI }));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_Annexe;

        const IsDownload = this.Download_Annexe_FIN(URL, Annexe.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el anexo del Proceso, informa a tu supervisor!'
      })
    }

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Download_Annexe_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const Container_Download_Annexe = document.getElementById('Container-Download-Annexe') as HTMLDivElement;
      const Progress_Bar_Annexe = document.getElementById('Progress-Bar-Annexe') as HTMLDivElement;

      Container_Download_Annexe.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Annexe.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Anexo descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el anexo del Proceso, informe a su supervisor!'
          })

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //-============== FUNCTION TO SHOW MESSAGE FOR NOT HAVING PERMISSION TO DOWNLOAD ANNEX ==============-\\
  private Message_NP_Download_Annexe(Annexe: Annexe): void {

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'warning',
      title: '¡No tiene permisos para descargar este anexo!'
    })
  }

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public CutNameFile(Name: string, length: number): string {

    if (Name !== undefined) {
      if (Name.length > length) {
        const Ext = Name.split('.').pop();
        const NameCut = Name.slice(0, length);
        return NameCut + '....' + Ext;
      } else {
        return Name;
      }

    } else {
      return '';
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL VERSION HISTORY =====================&\\



  //&===================== FUNCTIONS FOR PERMISSIONS =====================&\\

  public UserRoleIn(Permissions: tpermissionFolderFIN[]): boolean {

    for (const Role of this.Permission_FMH.Permission) {
      const PermissionsFound = Permissions.find((p: tpermissionFolderFIN) => {
        return (p.toUpperCase() === Role.toUpperCase());
      })
      if (PermissionsFound) {
        return true;
      }

    }

    return false;

  }

  //&===================== END FUNCTIONS FOR PERMISSIONS =====================&\\




  //&===================== FUNCTIONS FOR DOWNLOAD FILE =====================&\\

  public async Check_Version_FIN(FIN: FILE_FIN, Position: number): Promise<void> {

    const hasPermission = this.UserRoleIn([this.PermissionFIN.downloadVersionFlow]) || this.UserService.UserRoleGeneralIn([GeneralRoleCDMS.AdministratorFIN]);
    if (!hasPermission) {
      Swal.fire('Acción no permitida', 'No tienes permisos para descargar versiones del historial.', 'warning');
      return;
    }

    try {


      if (FIN.Status === 1) {

        this.Download_Print_Format(FIN, Position);

      } else if (FIN.ID_Next_Version === null) {

        const Res_Get_URL: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_FIN({ ID_FIN: FIN.ID, Type_D: Download_Log_FIN.D_VERSION_HISTO }));

        if (Res_Get_URL.success) {
          await this.DownloadFile(Res_Get_URL.operation.URL_FIN, Position, FIN.Name);
        } else {
          throw "error";
        }

      } else {

        const Res_Get_URL: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Last_Version_DownloadFIN({ ID_FIN: FIN.ID, Type_D: Download_Log_FIN.D_VERSION_HISTO }));

        if (Res_Get_URL.success) {
          await this.DownloadFile(Res_Get_URL.operation.URL_FIN, Position, FIN.Name);
        } else {
          throw "error";
        }

      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al descargar el Proceso, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  public async DownloadFile(URL: string, Position: number, File_Name: string): Promise<boolean> {

    return new Promise((resolve) => {

      const Btn_Download = document.getElementById(`Btn-Download${Position}`) as HTMLButtonElement;
      const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task${Position}`) as HTMLSpanElement;


      const Text_Btn = document.getElementById(`Text-Btn${Position}`) as HTMLElement;
      const Icon_Btn = document.getElementById(`Icon-Btn${Position}`) as HTMLElement;


      Btn_Download.classList.add('active');
      Btn_Download.disabled = true;

      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Task.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Progress_Bar_Task.style.width = '0%';
          Btn_Download.classList.remove('active');
          Btn_Download.disabled = false;

          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
          Text_Btn.innerHTML = 'Completada';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Proceso descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el Proceso, informe a su supervisor!'
          })

          Btn_Download.classList.remove('active');
          Btn_Download.disabled = false;
          Progress_Bar_Task.style.width = '0%';
          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
          Text_Btn.innerHTML = 'Error';

          resolve(false);
        }

      })
    })

  }

  // ============== FUNCTION FOR DOWNLOAD PRINT FORMAT ==============\\
  private async Download_Print_Format(FIN: FILE_FIN, Position: number): Promise<void> {

    const Btn_Download = document.getElementById(`Btn-Download${Position}`) as HTMLButtonElement;
    const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task${Position}`) as HTMLSpanElement;


    const Text_Btn = document.getElementById(`Text-Btn${Position}`) as HTMLElement;
    const Icon_Btn = document.getElementById(`Icon-Btn${Position}`) as HTMLElement;

    Btn_Download.classList.add('active');
    Btn_Download.disabled = true;

    try {

      const ResPrintFormat: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_Print_Format_FIN({ ID_FIN: FIN.ID, Type_D: Download_Log_FIN.D_PRINT_FORMATF }));

      const URL = ResPrintFormat.operation.URL_FIN_PF;


      let Name_Split: string[] = FIN.Name.split('.'); Name_Split.pop();

      const Name_Download: string = `${Name_Split.join('.')}.${URL.split('.').pop()}`

      if (ResPrintFormat.success) {

        const IsDownload = this.DownloadFile(URL, Position, Name_Download);

        if (!IsDownload) throw new Error('No file Download');

      } else {
        throw "ERROR";
      }


    } catch (error) {


      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el formato de impresión, informa a tu supervisor!'
      });

      Btn_Download.classList.remove('active');
      Btn_Download.disabled = false;
      Progress_Bar_Task.style.width = '0%';
      Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
      Text_Btn.innerHTML = 'Error';

    }

  }

  //&===================== END FUNCTIONS FOR DOWNLOAD FILE =====================&\\


}
